module.exports = __webpack_public_path__ + "img/member_reservation_banner.2e4b6eec.png";